import CommonActionType from './action/common';
import ControlActionType from './action/control';
import LoginActionType from './action/login';
import OprationLogActionType from './action/oprationLog';
import OrderActionType from './action/order';
import SingleVehiclePageActionType from './action/singleVehiclePage';
import WarningListPageActionType from './action/warningListPage';
import ImpassableAreaPageActionType from './action/impassableAreaPage';
import WorkOrder from './action/workOrder';
import CockpitInfo from './action/cockpitInfo';
export enum CommonFetchActionType {
  START_FETCH = 'START_FETCH',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILED = 'FETCH_FAILED',
}
export default {
  ...CommonActionType,
  ...ControlActionType,
  ...LoginActionType,
  ...OprationLogActionType,
  ...OrderActionType,
  ...SingleVehiclePageActionType,
  ...WarningListPageActionType,
  ...ImpassableAreaPageActionType,
  ...WorkOrder,
  ...CommonFetchActionType,
  ...CockpitInfo,
};
